import { ZanbatoClosedTransaction, ZanbatoPricingItem } from 'api';
import { CLOSED_TRANSACTION, EMPTY_VALUE_FOR_TABLE, ZANBATO_SOURCE } from 'common/constants/valuations';
import { formatCurrencyStr, getAsOfRecord, getCutoffDateStr } from '../ZXIndexValueCard.utils';
import { PreviewRow } from './SecondaryTransactionsPreviewModal.props';

export const buildPreviewRows = (
  pricing: ZanbatoPricingItem[],
  transactions: ZanbatoClosedTransaction[],
  measurementDate: string
): PreviewRow[] => {
  const rows: PreviewRow[] = [];

  const asOfRecord = getAsOfRecord(pricing, measurementDate);
  if (asOfRecord?.zx_index_value != null) {
    rows.push({
      key: 'zx-index-price',
      title: 'ZX Index Price',
      date: measurementDate ?? null,
      source: ZANBATO_SOURCE,
      size: EMPTY_VALUE_FOR_TABLE,
      pricePerShare: formatCurrencyStr(asOfRecord.zx_index_value),
    });
  }

  const cutoffStr = getCutoffDateStr(measurementDate);
  transactions
    .filter(transaction => {
      if (!transaction.closing_date) {
        return false;
      }
      if (cutoffStr && transaction.closing_date < cutoffStr) {
        return false;
      }
      if (measurementDate && transaction.closing_date > measurementDate) {
        return false;
      }
      return true;
    })
    .sort((a, b) => (b.closing_date ?? '').localeCompare(a.closing_date ?? ''))
    .forEach((transaction, index) => {
      rows.push({
        key: transaction.id != null ? String(transaction.id) : `closed-transaction-${index}`,
        title: transaction.security_type ? `${CLOSED_TRANSACTION} (${transaction.security_type})` : CLOSED_TRANSACTION,
        date: transaction.closing_date ?? null,
        source: ZANBATO_SOURCE,
        size: transaction.total_value ?? EMPTY_VALUE_FOR_TABLE,
        pricePerShare: formatCurrencyStr(transaction.price_per_share),
      });
    });

  return rows;
};
